import { apiFetch } from '@/services/api';
import { buildApiUrl } from '@/services/api-client';
import type { Filters } from '@/lib/filters-schema';
import type { ApiEnvelope, CampaignCard, CampaignListRow } from './api-types';

export function fetchCampaignList(filters: Filters): Promise<ApiEnvelope<CampaignListRow[]>> {
  return apiFetch(buildApiUrl('/salescoach/api/campaigns/list', filters));
}
export function fetchCampaignCard(filters: Filters, campaignId: string): Promise<ApiEnvelope<CampaignCard | null>> {
  return apiFetch(buildApiUrl('/salescoach/api/campaigns/card', filters, { campaignId }));
}
